/* eslint-disable react/no-unused-prop-types */
/* eslint-disable max-len */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { push, replace } from 'react-router-redux';
import { withTranslation } from 'react-i18next';
import moment from 'moment-timezone';
import clone from 'clone';
import qs from 'qs';
import {
  Button,
  Container,
  Grid,
  Header,
  Icon,
  Menu,
  Modal,
} from 'semantic-ui-react';

import { fetchM } from '../../../actions/fetchM';
import { flashSuccessMessage, flashErrorMessage } from '../../../actions/flash';

import NavBar from '../../../components/NavBar';
import CrmLinkBanner from '../../../components/Crm/CrmLinkBanner';
import DeleteConfirm from '../../../containers/modals/DeleteConfirm';
import { spaFullNumber } from '../../../utils/amount';
import { shareUnitToWSFormat, shareUnitCopyFormat } from '../../../utils/sharing';
import { decodeSearch, encodeSearch } from '../../../utils/url';
import { linkIDFromRoute } from '../../../utils/crmLink';
import { reservationBlocked } from '../../../utils/preSalesLaunch';
import { isVietnamCompany } from '../../../utils/vietnam';
import BookingSectionTab from '../../../components/Bookings/BookingSectionTab';
import { promptChangesMessage } from '../../../actions/prompt';
import { DEFAULT_PROMPT } from '../../../constants/promptMessages';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';
import Bookings from './Bookings';
import Lawyer from './Lawyer';
import Logs from './Logs';
import Info from './Info';
import { hasAnyRequiredRoleIDs, matchGroupIDToSrRoleID } from '../../../constants/srRoleAccess';

// Named alongside the wrapped default so a test can reach getBookingFormURL headless.
export class Overview extends Component {
  static propTypes = {
    token: PropTypes.string,
    id: PropTypes.string,
    unitID: PropTypes.string,
    appConfig: PropTypes.shape({
      data: PropTypes.shape({
        settings: PropTypes.shape({
          allowUnitSocialShare: PropTypes.bool,
        }),
      }),
    }),
    location: PropTypes.shape({
      query: PropTypes.object,
      search: PropTypes.string,
      pathname: PropTypes.string,
      hash: PropTypes.string,
    }),
    auth: PropTypes.shape({
      isDeveloper: PropTypes.bool,
      isSiteplan: PropTypes.bool,
      isBranchLeader: PropTypes.bool,
      isBranchLeaderSupervisorII: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isExternalAgencyAdmin: PropTypes.bool,
      company: PropTypes.shape({
        countryCode: PropTypes.string,
      }),
      companyBranch: PropTypes.shape({
        isExternal: PropTypes.bool,
      }),
      allowEditUnitPrice: PropTypes.bool,
      allowEditUnitDetails: PropTypes.bool,
    }),
    onCheck: PropTypes.func,
    data: PropTypes.shape({
      project: PropTypes.shape({
        maOwnerCompanyBranchID: PropTypes.number,
      }),
    }),
    packagePricingCalculation: PropTypes.oneOfType([PropTypes.array]),
    newFetch: PropTypes.func,
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    appConfig: state.appConfig,
    auth: state.auth,
  })
  static getPropsToState = (props) => {
    const windowWidth = window.innerWidth;
    const isMobile = windowWidth < 768;
    const query = decodeSearch(props.location.search);
    const srCode = typeof query.srCode === 'string' ? query.srCode : '';
    const hasSRCodeQuery = Object.prototype.hasOwnProperty.call(query, 'srCode');
    const data = props.data || {};
    const packagePricingCalculation = props.packagePricingCalculation || [];
    const editData = JSON.parse(JSON.stringify(data));
    const loading = props.loading;
    const galleryIsTab = window.innerWidth > 425;
    data.spaAmount = spaFullNumber(data) || data.spaValue; // decimal amount
    let tabID = 1;
    switch (query.section) {
      case 'info':
        tabID = 1;
        break;
      case 'bookings':
        tabID = 2;
        break;
      case 'lawyer':
        tabID = 3;
        break;
      case 'logs':
        tabID = 4;
        break;
      default:
        tabID = 1;
        break;
    }
    const sectionTabs = [
      { id: 1, title: 'Info', description: 'Unit, Pricing, Layout & Specification' },
    ];
    if (props.auth && !props.auth.isSiteplan) {
      sectionTabs.push({ id: 2, title: 'Bookings', description: 'Booking History' });
      sectionTabs.push({ id: 4, title: 'Logs', description: 'Activity Logs' });
    }
    if (data && data.lawyerEmail) {
      sectionTabs.push({ id: 3, title: 'Lawyer', description: 'SPA Lawyer Info' });
    }
    sectionTabs.sort((a, b) => a.id - b.id);
    return {
      data,
      editData,
      galleryIsTab,
      isMobile,
      loading,
      oriData: clone(data),
      sectionTabs,
      tabID,
      packagePricingCalculation,
      srCode,
      hasSRCodeQuery,
    };
  }
  constructor(props) {
    super(props);
    const state = Overview.getPropsToState(props);
    this.state = {
      ...state,
      edit: false,
      editTier: false,
      unitLayouts: [],
      hasChanges: false,
      modalReservationIsOpen: false,
      showDeleteConfirm: false,
      showQuotationOpts: false,
    };
    this.validation = {};
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
    this.consumeSRCodeQuery();
  }
  componentWillReceiveProps(nextProps) {
    const state = Overview.getPropsToState(nextProps);
    const sameUnitRoute = this.isSameUnitRoute(nextProps);
    this.setState(previousState => ({
      ...state,
      // A replace strips srCode from the address bar. Retain it only for this unit's Reserve link.
      srCode: state.hasSRCodeQuery ? state.srCode : (sameUnitRoute ? previousState.srCode : ''),
      hasSRCodeQuery: state.hasSRCodeQuery,
    }), this.consumeSRCodeQuery);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  setComponentState(state = {}, callback) {
    return new Promise((res) => {
      this.setState(state, () => {
        if (callback) {
          callback();
        }
        res(state);
      });
    });
  }
  async fetchProjectUnitLayouts() {
    const { store } = this.context;
    const { t } = this.props;
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/unit_layouts/`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (e) {
      Bugsnag.notifyException(e);
      await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const unitLayouts = await res.json();
      // handle token.. etc
      await this.setComponentState({
        unitLayouts: unitLayouts ? unitLayouts.map((ul) => {
          const unitLayout = { text: ul.name, name: ul.id, value: ul.id, size: ul.size };
          return unitLayout;
        }) : [],
      });
    }
  }
  async putUnit(validations, unit) {
    const { store } = this.context;
    const { t } = this.props;
    const query = decodeSearch(this.props.location.search);
    const errors = validations.filter(v => !v.isValid);
    if (errors.length > 0) {
      this.setState({ edit: true });
      store.dispatch(flashErrorMessage({ header: t('Please fix form errors', { ns: TRANSLATION_FILES.translation }), list: errors.map(l => l.message) }));
      return;
    }
    await this.setComponentState({ loading: true });
    let res;
    try {
      res = await store.dispatch(fetchM(`/projects/${this.props.id}/units/${this.props.unitID}/`, {
        credentials: 'include',
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
        body: JSON.stringify(unit),
      }));
    } catch (err) {
      Bugsnag.notifyException(err);
      await this.setComponentState({ loading: false });
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
      return;
    }
    const data = await res.json();
    await this.setComponentState({
      loading: false,
      edit: false,
      editTier: false,
    }, () => {
      this.handleResetCheck();
    });
    this.props.newFetch();
    store.dispatch(replace(`/projects/${this.props.id}/units/${this.props.unitID}/?${encodeSearch(query)}`));
    store.dispatch(flashSuccessMessage({
      header: t('Update Success', { ns: TRANSLATION_FILES.translation }),
      message: t('Unit {{reference}} is successfully updated', { reference: data.reference, ns: TRANSLATION_FILES.translation }),
    }));
  }
  async deleteUnit() {
    const { store } = this.context;
    const { data } = this.state;
    const { t } = this.props;
    await this.setState({ loading: true });
    try {
      await store.dispatch(fetchM(`/projects/${this.props.id}/units/${this.props.unitID}/`, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setState({ loading: false });
      Bugsnag.notifyException(err);
      if (err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      store.dispatch(flashErrorMessage(err));
    }
    await this.setState({ loading: false });
    store.dispatch(replace(`/projects/${this.props.id}/`));
    store.dispatch(flashSuccessMessage({
      header: t('Delete Success', { ns: TRANSLATION_FILES.translation }),
      message: t('Unit {{reference}} was successfully', { reference: data.reference, ns: TRANSLATION_FILES.translation }),
    }));
  }
  async deleteUnitPricingTier(id) {
    await this.setComponentState({ loading: true });
    const { store } = this.context;
    const { data } = this.state;
    const { t } = this.props;
    const newprojectUnitPricings = data.projectUnitPricings.filter(d => d.id !== id);
    const item = data.projectUnitPricings.find(d => d.id === id);
    try {
      await store.dispatch(fetchM(`/projects/${data.project.id}/units/${data.id}/pricings/${id}/`, {
        credentials: 'include',
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          'X-Csrf-Token': this.props.token,
        },
      }));
    } catch (err) {
      await this.setComponentState({ loading: false });
      if (err.res && err.res.status >= 400 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
        return;
      }
      Bugsnag.notifyException(err);
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    await this.setComponentState({ loading: false });
    store.dispatch(flashSuccessMessage({
      header: t('Pricing Deleted', { ns: TRANSLATION_FILES.translation }),
      message: t('{{pricing}} was successfully removed', { pricing: item.projectPricing.name, ns: TRANSLATION_FILES.translation }),
    }));
    data.projectUnitPricings = newprojectUnitPricings;
    await this.setComponentState({ data }, () => {
      this.handleCheckChanges();
      this.props.newFetch();
    });
  }
  handleOnCheck = (hasChanges = false) => {
    if (this.props.onCheck) {
      this.props.onCheck(hasChanges);
    }
  }
  handleCheckChanges() {
    if (!this.state.hasChanges) {
      this.setState({ hasChanges: true }, () => {
        this.handleOnCheck(true);
      });
    }
  }
  handleResetCheck() {
    if (this.state.hasChanges) {
      this.setState({ hasChanges: false }, () => {
        this.handleOnCheck(false);
      });
    }
  }
  handleResize = () => {
    const galleryIsTab = window.innerWidth > 425;
    const isMobile = window.innerWidth < 768;
    if (galleryIsTab !== this.state.galleryIsTab || isMobile !== this.state.isMobile) {
      this.setState({
        galleryIsTab,
        isMobile,
      });
    }
  };
  isSameUnitRoute = (nextProps) => {
    const currentPath = this.props.location.pathname ||
      `/projects/${this.props.id}/units/${this.props.unitID}/`;
    const nextPath = nextProps.location.pathname ||
      `/projects/${nextProps.id}/units/${nextProps.unitID}/`;
    return this.props.id === nextProps.id &&
      this.props.unitID === nextProps.unitID &&
      currentPath === nextPath;
  };
  handleTabChange = (tabData) => {
    const { data } = this.state;
    if (!tabData) return;
    const tabID = tabData.id;
    const { store } = this.context;
    const query = decodeSearch(this.props.location.search);
    let tab = 'info';
    switch (tabID) {
      case 1:
        tab = 'info';
        break;
      case 2:
        tab = 'bookings';
        break;
      case 3:
        tab = 'lawyer';
        break;
      case 4:
        tab = 'logs';
        break;
      default:
        tab = 'info';
        break;
    }
    query.section = tab;
    this.setState({
      tabID: this.state.hasChanges ? this.state.tabID : tabID,
    });
    if (tabData.page) {
      store.dispatch(push(`/projects/${data.projectID}/units/${data.id}/${tabData.page}`));
    } else {
      const callback = () => {
        if (this.state.hasChanges) {
          this.props.onCheck(false, this.setState({ tabID }));
        }
        if (tabData.isSticky) {
          // Scrolltop
          window.scrollTo(0, 150);
        }
        store.dispatch(replace(`/projects/${data.projectID}/units/${data.id}/?${encodeSearch(query)}`));
      };
      if (this.state.hasChanges) {
        store.dispatch(promptChangesMessage({ message: DEFAULT_PROMPT, callback }));
      } else {
        callback();
      }
    }
  }
  hasEditAccess(check = false) {
    const user = this.props.auth;
    if (this.props.auth.isSuperAdmin || this.props.auth.isHeadquarters) {
      return true;
    }
    if (this.props.auth.isBranchLeaderSupervisorII && this.props.data &&
      (this.props.data.project.maOwnerCompanyBranchID === user.companyBranch.id)
    ) {
      return true;
    }
    return check;
  }
  hasAccess(check = false) {
    const user = this.props.auth;
    if (this.props.auth.isHeadquarters || this.props.auth.isSuperAdmin) {
      return true;
    }
    if (this.props.auth.isBranchLeader && this.props.data &&
      (this.props.data.project.maOwnerCompanyBranchID === user.companyBranch.id)
    ) {
      return true;
    }
    return check;
  }
  hasAccessInternal() {
    const auth = this.props.auth;
    if (auth && auth.companyBranch && !auth.companyBranch.isExternal) {
      return true;
    }
    return false;
  }
  handleResetUnitLayout = () => {
    const editData = JSON.parse(JSON.stringify(this.state.data));
    this.setState({ editData }, () => {
      this.handleResetCheck();
    });
  }
  checkBookable = (statusID, project) => {
    const user = this.props.auth;
    switch (statusID) {
      case 'new':
      case 'reserved':
        return true;
      case 'delist':
        if (project && project.rduIsEnabled && project.rduAccessGroupIDs) {
          if (user.isAdminBasic || user.isAdmin) return true;

          const uGroupIDs = [...user.groups.map(obj => obj.id)];
          const uSrRoleIDs = matchGroupIDToSrRoleID(uGroupIDs, user.companyBranch.isExternal);
          return hasAnyRequiredRoleIDs(project.rduAccessGroupIDs, uSrRoleIDs);
        }
        return false;
      default:
        return false;
    }
  }
  // CPI-975: an agency user's Reserve follows the unit's agency allocation, and that is decided
  // by the server. book-api refuses the unit page (403) and the reserve itself for a unit that is
  // not allocated to the agent's branch, and returns a not-allocated unit as unavailable, which
  // checkBookable already disables. The blanket Vietnam-agency disable that CPI-974 R2 put here
  // is gone: it greyed the button for units the agency IS allocated, so no agent could reserve.
  // Agency Admin (MS-3013) is a non-selling role, so its Reserve stays disabled on every unit -
  // except in Vietnam, where SkyWorld's Agency Admins reserve for their agency and the button
  // follows the same server-side allocation gate as Agent and Agent Leader. MY/ID unchanged.
  checkCannotBookUnit = () => {
    const { auth } = this.props;
    if (isVietnamCompany(auth)) return false;
    return !!(auth && auth.isExternalAgencyAdmin);
  }
  handleModalReservationClose = () => {
    this.setState({ modalReservationIsOpen: false });
  }
  handleBookUnit = () => {
    this.setState({ modalReservationIsOpen: true });
  }
  checkBusinessUnitLimitReached = (unitData, user) => {
    if (unitData &&
      user && user.affiliate &&
      user.affiliate.companyBranch.reservationLimit !== 0 &&
      (unitData.companyBranchBookingReserveCount >= user.affiliate.companyBranch.reservationLimit)
    ) {
      return true;
    }
    return false;
  }
  checkLaunchModeTimeout = (data, user) => {
    if (
      data.project &&
      data.project.isLaunchMode &&
      moment().isBefore(moment(data.reservedTimeoutExpireAt)) &&
      data.reservedByAwsUser !== user.awsUsername
    ) {
      return true;
    }
    return false;
  }
  checkUserIsCooldown = (data) => {
    if (data.currentUserIsCooldown) return true;
    return false;
  }
  checkUserBapBanned = (data) => {
    if (data.bapUserBanned) return true;
    return false;
  }
  generateBookButtonText(data) {
    const { t } = this.props;
    let message = 'Book';
    if (data.project && data.project.defaultCustomBookingStatusID === 'reserved') {
      message = 'Reserve';
    }
    if (this.checkUserIsCooldown(data) || this.checkUserBapBanned(data)) {
      return (
        <div>
          <Icon name="wait" />
          {t(message)}
        </div>
      );
    }
    return t(message);
  }
  checkDisableBookButton(data) {
    const user = this.props.auth;
    const { edit, loading } = this.state;
    return loading ||
      edit ||
      (data && data.projectUnitBookingSummary && data.project &&
        data.projectUnitBookingSummary.reservedCount >= data.project.bookingUnitLimit) ||
      !this.checkBookable(data.statusID, data.project) ||
      this.checkLaunchModeTimeout(data, user) ||
      this.checkUserIsCooldown(data) ||
      this.checkUserBapBanned(data) ||
      reservationBlocked(user, data && data.project) ||
      this.checkCannotBookUnit();
  }

  hasPreviewPriceAccess = (check = true) => {
    const user = this.props.auth;
    const { data } = this.state;
    if (!user.isSuperAdmin &&
        !user.isHeadquarters &&
        !user.isMainHeadquarters
      ) {
      if (user.isExternalAgent || user.isExternalAgentLeader) {
        if (data.statusID !== 'new' && data.project && data.project.bookingUnitLimit < 2) {
          return false;
        }
      } else if (data.statusID !== 'new' && data.statusID !== 'reserved' && data.statusID !== 'developer_reserved') {
        return false;
      }
    }
    return check;
  }
  hasGenerateQuotationAccess = () => {
    const user = this.props.auth;
    const { data } = this.state;
    if (data.project && data.project.quotnIsEnabled && data.project.quotnAccessGroupIDs) {
      if (user.isAdminBasic || user.isAdmin) return true;

      const uGroupIDs = [...user.groups.map(obj => obj.id)];
      const uSrRoleIDs = matchGroupIDToSrRoleID(uGroupIDs, user.companyBranch.isExternal);
      return hasAnyRequiredRoleIDs(data.project.quotnAccessGroupIDs, uSrRoleIDs);
    }
    return false;
  }
  handleCancelDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDeleteConfirm: false,
    });
  }
  handleConfirmDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDeleteConfirm: false,
    }, () => {
      this.deleteUnit();
    });
  }
  handleDelete = (e) => {
    e.preventDefault();
    this.setState({
      showDeleteConfirm: true,
    });
  }
  canDelete = () => {
    const { data } = this.state;
    if (data.projectUnitBookingSummary) {
      if (data.projectUnitBookingSummary.totalCount < 1) return true;
    }
    return false;
  }
  generateWSLink = (data, user) => `https://wa.me/?text=${shareUnitToWSFormat(data, user, this.state.packagePricingCalculation)}`;
  handleCopyShareInfo = (e) => {
    e.preventDefault();
    const { store } = this.context;
    const { data } = this.state;
    const { t } = this.props;
    const user = this.props.auth;
    const copyText = shareUnitCopyFormat(data, user, this.state.packagePricingCalculation);
    const textArea = document.createElement('textarea');
    textArea.value = copyText;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand('Copy');
    textArea.remove();
    store.dispatch(flashSuccessMessage({
      header: t('Copy Success', { ns: TRANSLATION_FILES.translation }),
      message: t('Successfully copied unit details to your clipboard', { ns: TRANSLATION_FILES.translation }),
    }));
  }
  checkAllowUnitShare = () => {
    const { data } = this.props.appConfig;
    if (data && data.settings && data.settings.allowUnitSocialShare) return true;
    return false;
  }

  consumeSRCodeQuery = () => {
    if (!this.state.hasSRCodeQuery) return;
    const { store } = this.context;
    const { location } = this.props;
    const query = decodeSearch(location.search);
    delete query.srCode;
    const nextSearch = encodeSearch(query);
    const pathname = location.pathname || `/projects/${this.props.id}/units/${this.props.unitID}/`;
    const nextLocation = `${pathname}${nextSearch ? `?${nextSearch}` : ''}${location.hash || window.location.hash || ''}`;

    this.setState({ hasSRCodeQuery: false }, () => store.dispatch(replace(nextLocation)));
  }

  getBookingFormURL = () => {
    const queryParams = new URLSearchParams(window.location.search);
    const source = queryParams.get('source');
    const opportunityID = queryParams.get('opportunityID');
    const bookingID = queryParams.get('bookingID');
    const { srCode } = this.state;

    const q = Object.assign({
      projectID: this.props.id,
      unitID: this.props.unitID,
    });

    if (source) q.source = source;
    // The CRM link session this unit was chosen for (MS-6631): the unit list handed it on, and the
    // booking form needs it for the pre-fill and to mark the session consumed on submit.
    const crmLink = linkIDFromRoute({}, this.props.location);
    if (crmLink) q.crm_link = crmLink;
    if (opportunityID) q.opportunityID = opportunityID;
    if (bookingID) q.bookingID = bookingID;
    if (srCode) q.srCode = srCode;

    return `/bookings/new/?${qs.stringify(q)}`;
  }
  handleOnToggleQuotationOpts = check => this.setState({ showQuotationOpts: check });
  handleScrollPackagePricingIntoView = (e) => {
    e.preventDefault();
    const pricingPackageDiv = document.getElementById('pricing_package_div');
    if (pricingPackageDiv) {
      pricingPackageDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.handleOnToggleQuotationOpts(true);
    }
  }

  render() {
    const { data, oriData, galleryIsTab, isMobile, sectionTabs, tabID, showQuotationOpts, loading } = this.state;
    const user = this.props.auth;
    const { t } = this.props;
    const sectionProps = { ...this.props, isMobile, loading };
    return (
      <Container>
        <DeleteConfirm
          open={this.state.showDeleteConfirm}
          onClose={this.handleCancelDelete}
          onConfirm={this.handleConfirmDelete}
          name={data.reference || t('Unit')}
        />
        <Modal open={this.state.modalReservationIsOpen} basic size="small">
          <Header icon="warning sign" content={t('Reservation Limit Exceeded')} />
          <Modal.Content>
            <p>
              {t('Your business unit has reached it\'s reservation limit of {{limit}}. Please contact {{company}}',
                { limit: user.companyBranch.reservationLimit, company: user.company.name })}.
            </p>
          </Modal.Content>
          <Modal.Actions>
            <Button
              color="green"
              inverted
              onClick={this.handleModalReservationClose}
            >
              {t('Okay', { ns: TRANSLATION_FILES.translation })}
            </Button>
          </Modal.Actions>
        </Modal>
        <NavBar
          header={t('Overview')}
          backURL={`/projects/${this.props.id}/units/`}
          rightNav={
            this.props.auth.isSiteplan ? null : (
              <Menu.Item fitted>
                <div>
                  {
                    (oriData.virtualTourURL !== '' || (oriData.projectUnitLayout && oriData.projectUnitLayout.virtualTourURL !== '')) && (
                      <Button
                        as="a"
                        color="teal"
                        icon="street view"
                        content={galleryIsTab ? t('Virtual Tour') : null}
                        disabled={this.state.loading}
                        href={oriData.virtualTourURL || (oriData.projectUnitLayout ? oriData.projectUnitLayout.virtualTourURL : '')}
                        target="_blank"
                        rel="noopener noreferrer"
                        size={galleryIsTab ? 'medium' : 'small'}
                      />
                    )
                  }
                  {this.checkAllowUnitShare() ?
                    <Button
                      as={Link}
                      icon
                      color="green"
                      size={galleryIsTab ? 'medium' : 'small'}
                      title={t('Share details to Whatsapp')}
                      className="whatsapp-button large-hide"
                      to={this.generateWSLink(data, user)}
                      target="_blank"
                    >
                      <Icon name="whatsapp" />
                    </Button>
                    : ''
                  }
                  {
                    this.hasGenerateQuotationAccess() && (
                      <Button
                        icon
                        size={galleryIsTab ? 'medium' : 'small'}
                        title={t('Print quotation')}
                        className="mobile-hide"
                        onClick={this.handleScrollPackagePricingIntoView}
                      >
                        <Icon name="print" />
                      </Button>
                    )
                  }
                  {this.checkAllowUnitShare() ?
                    <Button
                      icon
                      size={galleryIsTab ? 'medium' : 'small'}
                      title={t('Copy sharing details')}
                      className="mobile-hide"
                      onClick={this.handleCopyShareInfo}
                    >
                      <Icon name="copy" />
                    </Button>
                    : ''
                  }
                  {(this.canDelete() && this.hasEditAccess() && (this.props.auth.allowEditUnitDetails || this.props.auth.allowEditUnitPrice)) &&
                    <Button
                      color="red"
                      disabled={this.state.loading}
                      icon
                      title={t('Delete', { ns: TRANSLATION_FILES.translation })}
                      onClick={this.handleDelete}
                      size={galleryIsTab ? 'medium' : 'small'}
                    >
                      <Icon name="trash" />
                    </Button>
                  }
                  <Button
                    as={this.checkBusinessUnitLimitReached(data, user) ? Button : Link}
                    positive
                    content={this.generateBookButtonText(data)}
                    disabled={this.checkDisableBookButton(data)}
                    to={!this.checkBusinessUnitLimitReached(data, user) && this.getBookingFormURL()}
                    onClick={this.checkBusinessUnitLimitReached(data, user) ?
                      this.handleBookUnit : () => { }
                    }
                    size={galleryIsTab ? 'medium' : 'small'}
                  />
                </div>
              </Menu.Item>
            )
          }
          bottomNode={
            <BookingSectionTab
              loading={this.state.loading}
              isMobile={isMobile}
              isSticky
              onTabChange={this.handleTabChange}
              tabs={sectionTabs}
              tabID={tabID}
            />
          }
        />
        {/* Whose booking this unit is being chosen for, when the page was reached from a CRM link
            without a unit (MS-6626 / MS-6631). Nothing without the id. */}
        <CrmLinkBanner linkID={linkIDFromRoute({}, this.props.location)} />
        <Grid>
          <Grid.Row>
            <Grid.Column>
              <BookingSectionTab
                loading={this.state.loading}
                isMobile={isMobile}
                onTabChange={this.handleTabChange}
                tabs={sectionTabs}
                tabID={tabID}
              />
            </Grid.Column>
          </Grid.Row>
          {
            tabID !== 1 ? (
              <Grid.Row>
                <Grid.Column textAlign="center">
                  {
                    data ? (
                      <div>
                        <Header as="h3" style={{ marginBottom: '0' }}>{data ? data.reference : ''}</Header>
                        {
                          data.project && data.projectUnitLayout &&
                          <Header.Subheader>
                            {data.project.name}, {data.projectUnitLayout.name}
                          </Header.Subheader>
                        }
                      </div>
                    ) : ''
                  }
                </Grid.Column>
              </Grid.Row>
            ) : null
          }
          <Grid.Row>
            <Grid.Column>
              {tabID === 1 &&
                <Info
                  {...sectionProps}
                  hasPreviewPriceAccess={this.hasPreviewPriceAccess()}
                  hasGenerateQuotationAccess={this.hasGenerateQuotationAccess()}
                  onToggleQuotationPreview={this.handleOnToggleQuotationOpts}
                  showQuotationOpts={showQuotationOpts}
                />
              }
              {tabID === 2 && <Bookings {...sectionProps} />}
              {tabID === 3 && <Lawyer {...sectionProps} />}
              {tabID === 4 && <Logs hasAccess={this.hasAccess(this.hasAccessInternal())} {...sectionProps} />}
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default withTranslation(namespaces)(connect(Overview.mapStateToProps)(Overview));



// WEBPACK FOOTER //
// ./src/containers/Project/Unit/Overview.jsx